/* tslint:disable */
import { DimaResults } from './dima-results';

/**
 */
export class ViewEquipTr {
    equipName?: string;
    dimaResult?: DimaResults;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-equip-tr.ts